import { motion } from "framer-motion";

const designs = [
  {
    id: 1,
    title: "E-commerce Dashboard",
    image: "/placeholder.svg",
    description: "A modern e-commerce dashboard design",
  },
  {
    id: 2,
    title: "Social Platform",
    image: "/placeholder.svg",
    description: "Social media platform interface",
  },
  {
    id: 3,
    title: "Travel App",
    image: "/placeholder.svg",
    description: "Travel application UI design",
  },
];

const UXDesigns = () => {
  return (
    <div className="min-h-screen py-20 px-4">
      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-4xl font-bold text-center mb-16"
      >
        Our UI/UX Designs
      </motion.h1>

      <div className="staggered-grid max-w-7xl mx-auto">
        {designs.map((design, index) => (
          <motion.div
            key={design.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="mb-4 break-inside-avoid"
          >
            <div className="relative rounded-xl overflow-hidden">
              <img
                src={design.image}
                alt={design.title}
                className="w-full h-auto"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 hover:opacity-100 transition-opacity">
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="text-xl font-semibold text-white mb-2">
                    {design.title}
                  </h3>
                  <p className="text-white/80">{design.description}</p>
                </div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default UXDesigns;